import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UnusedDevicesReport } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class CucmCdrUnusedDevicesContext {
  private $http = inject(HttpClient);

  _stateSource = new ReplaySubject<UnusedDevicesReport>(1); // Public so stages can update the state
  state$ = this._stateSource.asObservable();

  constructor() {
    this._init();
  }

  private _init(): void {
    this._getUnusedDevices().subscribe((unusedDevicesReport: UnusedDevicesReport) => {
      this._stateSource.next(unusedDevicesReport);
    });
  }

  private _getUnusedDevices: () => Observable<UnusedDevicesReport> = () =>
    this.$http.get<UnusedDevicesReport>('/services/cisco/reporting/utilizations/unused-devices');

  refreshUnusedDevices(): void {
    this._init();
  }
}
